<template>
    <a href="javascript:;" @click.prevent="scheduler" class="link" v-loading="loading">
        <slot name="label">
            {{ $l10n.__("Gérer les modèles de pages de planification") }}
        </slot>
    </a>
</template>

<script>
    import { getSchedulerConfiguration } from 'api/onboarding/scheduler/onboardingScheduler';
    import { goToUrl } from 'js/vue/helpers';
    import Feature     from 'Services/Feature';
    
    export default {
        data(){
            return {
                scriptIsReady: false,
                nylasConfiguration: null,
                loading: false,
            }
        },
        created(){
            this.loading = true;
            getSchedulerConfiguration().then(res => { 
                this.nylasConfiguration = res;
                this.loading = false;
            });
            let script = document.createElement('script')
            if (Feature.isEnabled('nylas-region-eu')){
                script.setAttribute('src', 'https://ireland.schedule.nylas.com/schedule-editor/v1.0/schedule-editor.js')
            } else {
                script.setAttribute('src', 'https://schedule.nylas.com/schedule-editor/v1.0/schedule-editor.js')
            }
            document.body.appendChild(script)
            this.scriptIsReady = true;
        },
        computed: {
            corpAddress() {
                const corpState = window.sellsyapp.$store.state.corp.mainAddress;
                return !!corpState && !!corpState.part1 && !!corpState.zip && !!corpState.town ? `${corpState?.part1}, ${corpState?.zip} ${corpState?.town}` : this.$l10n.__('Bureau');
            },
            meetMe() {
                const name = window.sellsyapp.$store.state.user.name;
                return _.isNil(name) || name === '' ? window.sellsyapp.$store.state.user.email : name;
            }
        },
        methods: {
            scheduler(){
                if(this.scriptIsReady && !!this.nylasConfiguration){
                    if(_.isNil(this.nylasConfiguration.accessToken)) return goToUrl(window.sellsyapp.$router.resolve({name: 'onboarding.scheduler'}).href);

                    // Invoke the schedule editor when a user clicks on the button
                    nylas.scheduler.show({
                        locale: window.sellsyapp.$store.state.user.locale.split('_')[0],
                        auth: {
                            // Account access_token with active calendar scope
                            accessToken: this.nylasConfiguration.accessToken, 
                        },
                        style: {
                            // Style the schedule editor
                            tintColor: '#32325d',
                            backgroundColor: 'white',
                        },
                        defaults: {
                            event: {
                                title: this.$l10n.__('Rendez-vous avec %s', this.meetMe),
                                duration: 30,
                                location: !!this.corpAddress ? this.corpAddress : ''
                            },
                            reminders: [
                                {
                                    'delivery_method': 'webhook',
                                    'delivery_recipient': 'owner',
                                    'time_before_event': 43200,
                                    'webhook_url': window.webhookHost + '/nylas/scheduler'
                                }
                            ]
                        },
                    });
                } else{
                    Push.error('Script no ready yet, please retry', false)
                }
            }
        }
    }
</script>
